import firebase from "config/firebase";
import { toast } from "react-toastify";
export const getSportsCommunityBadge =
  (onSuccess = () => {}) =>
  async (dispatch) => {
    return firebase
      .firestore()
      .collection("sports_community_badges")
      .orderBy("createdAt", "desc")
      .onSnapshot(
        async (querySnapshot) => {
          const promises = querySnapshot.docs.map(async (doc) => {
            const badge = { id: doc.id, ...doc.data() };
            if (badge.userID) {
              const userDoc = await firebase
                .firestore()
                .collection("users")
                .doc(badge.userID)
                .get();

              if (userDoc.exists) {
                return {
                  ...badge,
                  userData: { id: userDoc.id, ...userDoc.data() },
                };
              }
            }

            return badge;
          });
          const badgesWithUsers = await Promise.all(promises);
          
          const uniqueMembers = badgesWithUsers.reduce((acc, current) => {
            const existingMember = acc.find(
              (item) => item.userID === current.userID
            );
            if (!existingMember) {
              acc.push(current);
            }
            return acc;
          }, []);
          
          dispatch({
            type: "SET_SPORTS_COMMUNITY_BADGE",
            payload: uniqueMembers,
          });
          onSuccess();
        },
        (error) => {
          console.error("Error in real-time badge listener:", error);
        }
      );
  };

export const sendNotification = (
  role,
  notificationText,
  onSuccess = () => {}
) => {
  return async () => {
    try {
      const notificationData = {
        notificationFor: role,
        message: notificationText,
        createdAt: new Date(),
        type: "Sports Community Badge",
        isRead: [],
      };
      await firebase
        .firestore()
        .collection("community_badges_notifications")
        .add(notificationData);
      toast.success("Notification sent successfully");
      onSuccess();
    } catch (error) {
      console.error("Error sending notification:", error);
      toast.error("Failed to send notification");
    }
  };
};
